module.exports = __webpack_public_path__ + "e0dddd183373a2c28ba103f47cd55a0d.woff2";